import React, { PropTypes, cloneElement } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import DumbComponent from './dumb-component';

const AssetsConsolidationContainer = props => {
  return <DumbComponent {...props} />;
}

const mapStateToProps = ({ assetsConsolidation, user }) => {
  return ({
    ...assetsConsolidation,
    consolidationSuccess: assetsConsolidation.consolidationSuccess,
    companyType: user.toJS().company.companyType,
  });
};

const mapDispatchToProps = dispatch => ({
  
});
export default connect(mapStateToProps, mapDispatchToProps)(AssetsConsolidationContainer);




// WEBPACK FOOTER //
// ./src/app/components/assets-consolidation/container.jsx